import React from "react";
import style from "./style.module.css";

export default function BrandKitSearchSpacer() {
  return <div className={style.searchSpacer} />;
}
